'use client';

import { Center, Loader, Text } from '@mantine/core';
import { useTranslation } from '@/i18n/client';

export default function Loading({ size }: { size?: string }) {
  const { t } = useTranslation('custom');

  return (
    <Center c='white'>
      <Loader size={size ? size : 'sm'} m={30} />
      <Text size={size ? size : 'sm'}>{t('loading')}...</Text>
    </Center>
  );
}
